import HeroSection from "../components/HeroSection";
import PowerSystemsLanding from "../components/PowerSystemsLanding";
import ProductsSection from "../components/ProductsSection";
import Footer from "./Footer";


const Home = () => {
  return (
    <div className="min-h-screen">
    <HeroSection />
      <ProductsSection />
      <PowerSystemsLanding />
      
    </div>
  );
};

export default Home;